<template>
  <v-dialog v-model="value" width="500" persistent v-if="value">
    <v-card>
      <v-card-text style="padding-left: 38px; padding-right: 22.25px; padding-bottom: 49px; padding-top: 21.25px;">
        
        <div style="display: flex; flex-direction: row; align-items: end; justify-content: space-between;">
          <!-- Title ค้นหา -->
          <div style=" font-size: 24px; font-weight: 700;">{{ 'ค้นหา' }}</div>

          <!-- ปุ่มปิด X -->
          <div>
            <v-btn flat fab small @click="$emit('input', false)" style="margin-bottom: 30px;">
              <v-icon style="width: 13.5px; height: 13.5px;">close</v-icon>
            </v-btn>
          </div> 
          
        </div>
        
        

        <template>
          <!-- Tag ค้นหา ชื่อ -->
          <div
            class="caption"
            style="padding-top: 25px !important; font-size: 16px !important; font-weight: 600 !important;"
          >
            {{ 'ค้นหา' }}
          </div>
          <!-- ช่องค้นหา ชื่อ -->
          <div class="form-control">
            <input type="text" v-model="input.search" />
          </div>

          <!-- <div class="caption">{{ $t('Status') }}</div>
          <div class="form-control">
            <input type="text" v-model="input.status" :placeholder="$t('Status')" />
          </div> -->
          <!-- Tag ค้นหา ป้ายกำกับ -->
          <div
            class="caption"
            style="padding-top: 25px !important; font-size: 16px !important; font-weight: 600 !important;"
          >
            {{ 'ป้ายกำกับ' }}
          </div>
          <!-- ช่องค้นหา ป้ายกำกับ -->
          <multiselect
            class="multi-tag-small"
            :options="tagOptions"
            v-model="input.tags"
            :placeholder="''"
            :multiple="true"
            :taggable="true"
            @tag="$emit('addTag', $event)"
            style="padding-bottom: 44.7px; cursor: pointer;"
          >
            <!-- @tag="$emit('addTag')" -->
          </multiselect>
        </template>
        <v-layout>
          <v-flex class="pa-1">
            <v-btn
              block
              depressed
              @click="$emit('clearSearch')"
              style="font-weight: 700; margin: 0 auto; color: #0C2F53; border: 1px solid #0C2F53; border-radius: 6px; background-color: white !important; width: 142px; height: 38px;"
            >
              <!-- <v-icon>clear</v-icon> -->
              {{ 'ยกเลิก' }}
            </v-btn>
          </v-flex>
          <v-flex class="pa-1">
            <v-btn
              block
              depressed
              @click="$emit('onSearch')"
              color="primary"
              style="margin: 0 auto; color: #FFEF01; width: 142px; height: 38px; font-weight: 700;"
            >
              <!-- <v-icon>search</v-icon> -->
              {{ 'ค้นหา' }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: false
    },
    input: {
      type: String,
      tags: { type: Array }
    },
    tagOptions: {
      type: Array
    }
  },
  components: {
    Multiselect
  },
  data() {
    return {}
  },
  // data() {
  //   return {
  //     tagOptions: [],
  //     input: {
  //       uuAreaName: '',
  //       search: '',
  //       uu_register_status: '',
  //       lastconversationfromdate: null,
  //       lastconversationtodate: null,
  //       lastconversationfromtime: null,
  //       lastconversationtotime: null,
  //       lastconversationfrom: null,
  //       lastconversationto: null,
  //       phoneno: null,
  //       uu_name: null,
  //       keyword: '',
  //       tags: [],
  //       status: null,
  //       app: '',
  //       session: '',
  //       assignadminname: '',
  //       realname: '',
  //       cardnumber: '',
  //     },
  //     openStartDate: false,
  //     openEndDate: false,
  //     openStartTime: false,
  //     openEndTime: false,
  //   }
  // },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    }
  }
  // methods: {
  //   addTag(newTag) {
  //     const tag = newTag
  //     this.tagOptions.push(tag)
  //     this.input.tags.push(tag)
  //   },
  // }

  // methods: {
  //   clearSearch() {
  //     this.input = {
  //       uuAreaName: '',
  //       search: '',
  //       uu_register_status: '',
  //       lastconversationfromdate: null,
  //       lastconversationtodate: null,
  //       lastconversationfromtime: null,
  //       lastconversationtotime: null,
  //       lastconversationfrom: null,
  //       lastconversationto: null,
  //       phoneno: null,
  //       uu_name: null,
  //       keyword: '',
  //       tags: [],
  //       status: null,
  //       app: '',
  //       realname: '',
  //       cardnumber: '',
  //     }
  //     this.onSearch()
  //   },
  //   onSearch() {
  //     let vm = this
  //     if (vm.input.lastconversationfromdate) {
  //       vm.input['lastconversationfrom'] =
  //         vm.input.lastconversationfromdate +
  //         (vm.input.lastconversationfromtime ? ' ' + vm.input.lastconversationfromtime : ' 00:00')
  //     } else {
  //       vm.input['lastconversationfrom'] = null
  //     }

  //     if (vm.input.lastconversationtodate) {
  //       vm.input['lastconversationto'] =
  //         vm.input.lastconversationtodate +
  //         (vm.input.lastconversationtotime ? ' ' + vm.input.lastconversationtotime : ' 23:59')
  //     } else {
  //       vm.input['lastconversationto'] = null
  //     }

  //     vm.$store.commit('SET_LIVECHAT_FILTER', vm.input)

  //     vm.usersearching = true
  //     vm.$nextTick(() => {
  //       vm.$store.dispatch('forceLoadLastestUsers').then(() => {
  //         vm.usersearching = false
  //       })
  //       vm.$emit('input', false)
  //     })
  //   },
  //   addTag(newTag) {
  //     const tag = newTag
  //     this.tagOptions.push(tag)
  //     this.input.tags.push(tag)
  //   },
  // },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatSearch.vue